//============================================================================
// Name        : compare_v2_details.ts
// Purpose     : Implement actions on the Compare detailed comparison page
// Created     : 2026-07-30
// Author      : Senitron Team
// Copyright   : Copyright 2026 Senitron Corporation. All rights reserved.
//============================================================================

import axios from "axios";
import { InitPageStrict } from "../index";

class CompareV2Details {
  root: HTMLElement;
  toggleExcludeUrl: string;
  viewOnly: boolean;
  previewDataUrl: string;

  constructor(root: HTMLElement) {
    this.root = root;
    this.toggleExcludeUrl = root.dataset.toggleExcludeUrl;
    this.viewOnly = root.dataset.viewOnly === "true";
    this.previewDataUrl = root.dataset.previewDataUrl;

    this.bindPerPage();
    this.bindViewFilters();
    this.bindExcludeToggle();
    this.bindImportCatalog();
    this.fetchPreviewData();
  }

  fetchPreviewData() {
    axios.get(this.previewDataUrl).then((response) => {
      const data = response.data;
      $("#last_full_cycle_count").text(data.last_full_cycle_count);
      $("#last_sync_time").text(data.last_sync_time);
      $("#last_dl_time").text(data.last_dl_failed ? "FAILED" : data.last_dl_time);
      $("#last_bulk_import_qty").text(data.last_bulk_import_qty);
      $("#count_of_all_lightspeed_import").prop("title", `${data.count_of_all_lightspeed_import} Record(s)`);
      $("#last_sync_count").prop("title", `${data.last_sync_count} Record(s)`);

      if (data.last_dl_failed) {
        $("#last_dl_time").addClass("text-danger");
      } else {
        $("#last_download_success").text("success");
      }
    }).catch((error) => console.error(error));
  }

  bindImportCatalog() {
    $(document).on("click", "[data-behavior~=import-catalog]", () => {
      $("#import_catalog").modal();
    });
  }

  bindPerPage() {
    $(this.root).on("change", "#itemscount", () => {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set("per_page", $("#itemscount").val() as string);
      window.location.search = searchParams.toString();
    });
  }

  // SC-6294: a filter (category, manufacturer, $ impact, Hide matched items) reloads the page with it.
  bindViewFilters() {
    $(this.root).on("change", ".js-details-filter", (e) => {
      ($(e.currentTarget).closest("form")[0] as HTMLFormElement).submit();
    });
  }

  bindExcludeToggle() {
    $(this.root).on("click", ".ext_sync", (e) => {
      if (this.viewOnly) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
      $.post(this.toggleExcludeUrl, { item_number: $(e.currentTarget).data("item_number") });
    });
  }
}

export function LoadPage() {
  InitPageStrict("lightspeed compare_v2_details", () => {
    const root = document.querySelector("#compare_details_root") as HTMLElement;
    if (root == null) {
      return;
    }
    new CompareV2Details(root);
  });
}
